import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Contact Info
      {record ? `: ${record.name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ContactInfo/Title.js